import { getGroupOpenedChatIds } from '../selectors/getGroupOpenedChatIds';
import { TChatGroupId } from '../../../../../types/rest/IRestChatGroup';
import { TChatId } from '../../../../../types/rest/IRestChat';

export const GROUPS_OPEN_CHAT_IDS_SESSIONSTORAGE = 'GROUPS_OPEN_CHAT_IDS_SESSIONSTORAGE';

export const setGroupOpenedChatId = (
    groupId: TChatGroupId,
    chatId: TChatId
) => {
    sessionStorage.setItem(GROUPS_OPEN_CHAT_IDS_SESSIONSTORAGE, JSON.stringify({
        ...getGroupOpenedChatIds(),
        [groupId]: chatId,
    }));
}
